import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import Button from "@/components/base/Button";
import { useGaleria } from "@/hooks/usePublicContent";

export default function GallerySection() {
  const items = useGaleria().filter((item) => item.activo);
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <Container>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Nuestros trabajos"
            title="Operaciones que ya realizamos"
            description="Una muestra de mudanzas, acarreos, eventos y distribución ejecutados por nuestro equipo."
          />
          <Button to="/trabajos" variant="outline" size="md" iconRight="ri-arrow-right-line" className="shrink-0">
            Ver todos los trabajos
          </Button>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-3">
          {items.slice(0, 6).map((item, index) => (
            <Link
              key={item.id}
              to="/trabajos"
              className={`group relative overflow-hidden rounded-lg bg-background-200 animate-fade-up ${
                index === 0 ? "col-span-2 row-span-2 h-64 sm:h-80 lg:h-full lg:min-h-[420px]" : "h-40 sm:h-52 lg:h-[200px]"
              }`}
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <img
                src={item.imagen_url}
                alt={`${item.titulo} — trabajo realizado por AXONIA GROUP`}
                title={`${item.titulo} — ${item.categoria}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <span className="text-[11px] font-label font-semibold uppercase tracking-wider text-accent-300">
                  {item.categoria}
                </span>
                <p className="mt-1 text-sm font-heading font-semibold text-primary-50 md:text-base">
                  {item.titulo}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}